<template>
 <div>
   <div style="width: 100%;height: 40px"></div>
   <div class="ctitle">
     <img class="service-around" :src="title">
     <div class="title-en">{{desc}}</div>
   </div>
 </div>
</template>

<script>
  export default {
    name: "CTitle",
    props:{
      title:{
        type:String
      },
      desc:{
        type:String
      }
    }
  }
</script>

<style scoped>
  .ctitle {
    display: flex;
    margin: 0 auto;
    width: 1070px;
    align-items: center;
  }

  .service-around {
    width: 91px;
    height: 23px;
  }
  .title-en{
    font-size: 24px;
    font-family: Roboto-Light, Roboto;
    font-weight: 300;
    color: #2E25CF;
    opacity: 0.5;
    margin-left: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CTitle.vue